import {post} from './api'
import { getServerInfo } from '../utils/helpers/networkInfo.helper';

const serverUrl = getServerInfo('api');
export class GuacamoleService {
    static getEncryptToken(data, token) {
        return post(`${serverUrl}encrypt`, data, true, token)
    }
}